export const Switch = {
  baseStyle: {
    thumb: {
      bg: 'white',
      border: '1px solid',
      borderColor: 'gray.300',
      borderRadius: 'full',
      _checked: {
        bg: 'primary.normal',
      },
    },
    track: {
      bg: 'gray.100',
      _checked: {
        bg: 'gray.600',
      },
      _dark: { bg: 'black.800' },
    },
  },
}
